import React from 'react';
import classNames from 'classnames';
import styles from './SkipLinks.module.scss';
import { Link, List, ListItem } from 'components/core';

export type SkipLinksProps = {
  links?: {
    href: string;
    name: string;
  }[];
  hasContainer?: boolean;
};

const mainContentLink = {
  name: 'Skip to main content',
  href: '#main',
};
const footerLink = {
  name: 'Skip to footer',
  href: '#footer',
};

const defaultLinks = [mainContentLink, footerLink];

const SkipLinks = ({
  links = defaultLinks,
  hasContainer = true,
}: SkipLinksProps) => {
  return (
    <div className={styles.wrapper}>
      <List
        className={classNames(styles.list, {
          [styles.container]: hasContainer,
        })}
        component="ol"
      >
        {links.map(({ href, name }) => (
          <ListItem key={href}>
            <Link variant="primary" to={href} className={styles.link}>
              {name}
            </Link>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

const SkipLinksWithoutFooter = (props: SkipLinksProps) => (
  <SkipLinks links={[mainContentLink]} {...props} />
);

export { SkipLinks, SkipLinksWithoutFooter };
